export default "__VITE_ASSET__DGfuHdEh__"